<template>
  <form-section
    :title="$t('CampaignForm_Onsite_Title_Button', { btn: button })"
    class="checkbox"
  >
    <form-item prop="label" :label="$t('CampaignForm_Onsite_Field_Label')">
      <el-input v-model="value.text" data-qa="onsite-btn-label-input" />
    </form-item>
    <form-item
      prop="action"
      :label="$t('CampaignForm_Onsite_Field_DefaultAction')"
    >
      <enum-select
        :options="buttonActions"
        v-model="value.action"
        data-qa="onsite-btn-action-dropdown"
      />
    </form-item>
    <!-- Actions -->
    <form-item
      v-if="value.action === 'url'"
      prop="url"
      :label="$t('CampaignForm_Onsite_Field_Url')"
    >
      <el-input v-model="value.url" data-qa="onsite-redirect-url-input" />
    </form-item>
    <form-item v-if="value.action === 'url'" prop="url_blank">
      <checkbox
        label="url_blank"
        :title="$t('CampaignForm_Onsite_Field_UrlBlank')"
        v-model="value.url_blank"
        data-qa="onsite-redirect-url-checkbox"
      />
    </form-item>
    <form-item
      v-if="value.action === 'javascript'"
      prop="javascript"
      :label="$t('CampaignForm_Onsite_Field_Javascript')"
    >
      <el-input
        type="textarea"
        v-model="value.javascript"
        data-qa="onsite-action-js-input"
      />
    </form-item>
    <form-item prop="special" :label="$t('CampaignForm_Onsite_Field_Save')">
      <enum-select
        :options="specialActions"
        v-model="value.special"
        data-qa="onsite-btn-save-dropdown"
      />
    </form-item>
    <form-item class="p-top-8" v-if="value.special && value.special !== 'none'">
      <el-row v-if="value.special === 'set_attribute'">
        <el-col :span="12">
          <el-autocomplete
            v-model="value.set_attribute.name"
            :fetch-suggestions="querySearchAttrs"
            data-qa="onsite-btn-save-attribute-key-input"
          />
        </el-col>
        <el-col :span="12">
          <el-input
            v-model="value.set_attribute.value"
            data-qa="onsite-btn-save-attribute-value-input"
          />
        </el-col>
      </el-row>
      <el-select
        v-if="value.special === 'add_to_list'"
        v-model="value.add_to_list"
        filterable
        remote
        :remote-method="fetchUserListsRemote"
        :loading="loadingUserList"
        data-qa="onsite-btn-save-list-input"
      >
        <el-option
          v-for="item in userListOptions"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </form-item>
    <form-item
      prop="special_2"
      :label="$t('CampaignForm_Onsite_Field_Subscribe')"
    >
      <enum-select
        :options="subscribeActions"
        v-model="value.special_2"
        data-qa="onsite-btn-subscribe-dropdown"
      />
    </form-item>
    <form-item class="p-top-8" v-if="value.special_2 === 'subscribe_to'">
      <el-select
        v-model="subscribeTo"
        multiple
        filterable
        remote
        :remote-method="fetchListsRemote"
        :loading="loadingList"
        data-qa="onsite-btn-subscribe-list-input"
      >
        <el-option
          v-for="item in listOptions"
          :key="item.id"
          :label="`${item.name} (${item.channel})`"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </form-item>
    <form-item prop="trigger" :label="$t('CampaignForm_Onsite_Field_Trigger')">
      <enum-select
        :options="triggerActions"
        v-model="value.trigger"
        data-qa="onsite-btn-trigger-dropdown"
      />
    </form-item>
    <form-item class="p-top-8" v-if="value.trigger === 'trigger_event'">
      <el-autocomplete
        v-model="value.trigger_event"
        :fetch-suggestions="querySearchEvents"
        data-qa="onsite-btn-trigger-list-input"
      />
    </form-item>
  </form-section>
</template>

<script>
import EnumSelect from '@/common/components/form/EnumSelect'
import FormItem from '@/common/components/form/FormItem'
import FormSection from '@/common/components/form/FormSection'
import { projectEndpoint, querySearch } from '@/core/helpers'
import RestApi from '@/core/services/RestApi'
import Checkbox from '@/common/components/form/Checkbox'

export default {
  name: 'OnSiteButtonForm',
  components: { Checkbox, FormSection, FormItem, EnumSelect },
  mounted() {
    this.fetchListsRemote()
    this.fetchUserListsRemote()
  },
  data() {
    return {
      loadingList: false,
      loadingUserList: false,
      listOptions: [],
      userListOptions: [],
      buttonActions: {
        none: 'CampaignForm_Onsite_Action_None',
        dismiss: 'CampaignForm_Onsite_Action_Dismiss',
        submit: 'CampaignForm_Onsite_Action_Submit',
        url: 'CampaignForm_Onsite_Action_Redirect',
        javascript: 'CampaignForm_Onsite_Action_Javascript'
      },
      specialActions: {
        none: 'CampaignForm_Onsite_Action_None',
        set_attribute: 'CampaignForm_Onsite_Action_SetAttr',
        add_to_list: 'CampaignForm_Onsite_Action_AddToList'
      },
      subscribeActions: {
        '': 'CampaignForm_Onsite_Action_None',
        subscribe_to: 'CampaignForm_Onsite_Action_SubscribeTo'
      },
      triggerActions: {
        '': 'CampaignForm_Onsite_Action_None',
        trigger_event: 'CampaignForm_Onsite_Action_TriggerEvent'
      }
    }
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    button: {
      default: '1'
    }
  },
  computed: {
    subscribeTo: {
      get() {
        if (this.value.subscribe_to) {
          if (!Array.isArray(this.value.subscribe_to)) {
            return this.value.subscribe_to.split(',').map(Number)
          }
          return this.value.subscribe_to
        }
        return []
      },
      set(val) {
        this.value.subscribe_to = val.join(',')
      }
    }
  },
  methods: {
    querySearchAttrs(queryString, cb) {
      return querySearch(`tags`, { sort: 'title', title: queryString }, cb)
    },
    fetchUserListsRemote(queryString) {
      this.loadingUserList = true
      return RestApi(
        projectEndpoint({
          method: 'get',
          url: `lists`,
          params: {
            sort: 'name',
            name: queryString,
            identifier: ['profile_id', 'device_id']
          }
        })
      )
        .then(({ data }) => {
          this.userListOptions = data
          this.loadingUserList = false
        })
        .catch(error => {
          this.loadingUserList = false
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },
    fetchListsRemote(queryString) {
      this.loadingList = true
      return RestApi(
        projectEndpoint({
          method: 'get',
          url: `subscription-preferences`,
          params: { sort: 'title', title: queryString }
        })
      )
        .then(({ data }) => {
          this.listOptions = data
          this.loadingList = false
        })
        .catch(error => {
          this.loadingList = false
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },
    querySearchEvents(queryString, cb) {
      return querySearch(`events`, { sort: 'title', title: queryString }, cb)
    }
  }
}
</script>

<style scoped>
.checkbox {
  background-color: #f8fafc;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/content/channels/OnSiteButtonForm.vue